import React from 'react'
import './cta.css'

const Cta = () => {
  return (
    <div className='cta section_margin section_padding ' id='features'>
      <div className='cta_content'>
        <p>Request Early Access to Get Started</p>
        <h1>Register today & start exploring the endless possiblities.</h1>
      </div>
      <button type='button'>Get Started</button>
    </div>
  )
}

export default Cta